module.exports = __webpack_public_path__ + "img/r-165.ad8ce9b5.jpg";